export default __webpack_public_path__ + "4d694e7616ebb38a8c718a55c427ae31.png";